var _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _ellipse, _ellipse2, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 52,
    viewBox: "0 0 106 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6855 9.83887C15.6269 7.41118 17.7522 5.63945 20.3097 5.1503L25.768 4.10633L10.8891 43.6808C9.45744 47.4886 5.26766 49.4789 1.41155 48.1831L-1.73327e-05 47.7087L14.6855 9.83887Z",
    fill: "#1A33B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6855 9.83887C15.6269 7.41118 17.7522 5.63945 20.3097 5.1503L25.768 4.10633L10.8891 43.6808C9.45744 47.4886 5.26766 49.4789 1.41155 48.1831L-1.73327e-05 47.7087L14.6855 9.83887Z",
    fill: "black",
    fillOpacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.979,
    y: 4.95044,
    width: 6.38015,
    height: 29.4621,
    rx: 1.8886,
    transform: "rotate(20.4781 26.979 4.95044)",
    fill: "#1A33B2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.979,
    y: 4.95044,
    width: 6.38015,
    height: 29.4621,
    rx: 1.8886,
    transform: "rotate(20.4781 26.979 4.95044)",
    fill: "black",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.3081,
    y: 8.83191,
    width: 5.63427,
    height: 24.1741,
    rx: 1.8886,
    transform: "rotate(19.9961 34.3081 8.83191)",
    fill: "#1A33B2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.3081,
    y: 8.83191,
    width: 5.63427,
    height: 24.1741,
    rx: 1.8886,
    transform: "rotate(19.9961 34.3081 8.83191)",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0597 20.8869C38.4342 19.9134 39.527 19.4279 40.5004 19.8024L41.9106 20.3449C42.884 20.7194 43.3696 21.8122 42.9951 22.7857L39.9901 30.5964C39.241 32.5434 37.0555 33.5145 35.1085 32.7655L33.6984 32.223L38.0597 20.8869Z",
    fill: "#1A33B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0597 20.8869C38.4342 19.9134 39.527 19.4279 40.5004 19.8024L41.9106 20.3449C42.884 20.7194 43.3696 21.8122 42.9951 22.7857L39.9901 30.5964C39.241 32.5434 37.0555 33.5145 35.1085 32.7655L33.6984 32.223L38.0597 20.8869Z",
    fill: "black",
    fillOpacity: 0.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.633,
    cy: 15.0202,
    rx: 2.91756,
    ry: 2.64404,
    transform: "rotate(21.043 42.633 15.0202)",
    fill: "#1A33B2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.633,
    cy: 15.0202,
    rx: 2.91756,
    ry: 2.64404,
    transform: "rotate(21.043 42.633 15.0202)",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.55 26.5076V31.9076H48.03V19.3076H55.752V21.4676H50.55V24.3476H54.672V26.5076H50.55ZM57.7331 31.9076V19.3076H60.2531V31.9076H57.7331ZM65.8254 23.7536V31.9076H63.3054V19.3076H65.6634L71.0994 27.4616H71.1354V19.3076H73.6554V31.9076H71.2974L65.8614 23.7536H65.8254ZM82.5495 19.3076L87.0495 31.9076H84.5655L83.6115 29.1896H78.8955L77.9415 31.9076H75.4575L79.9575 19.3076H82.5495ZM81.2355 22.4756L79.6515 27.0296H82.8375L81.2715 22.4756H81.2355ZM88.8464 31.9076V19.3076H91.3664V29.7476H95.6684V31.9076H88.8464ZM97.653 31.9076V19.3076H100.173V29.7476H104.475V31.9076H97.653Z",
    fill: "#1A33B2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.55 26.5076V31.9076H48.03V19.3076H55.752V21.4676H50.55V24.3476H54.672V26.5076H50.55ZM57.7331 31.9076V19.3076H60.2531V31.9076H57.7331ZM65.8254 23.7536V31.9076H63.3054V19.3076H65.6634L71.0994 27.4616H71.1354V19.3076H73.6554V31.9076H71.2974L65.8614 23.7536H65.8254ZM82.5495 19.3076L87.0495 31.9076H84.5655L83.6115 29.1896H78.8955L77.9415 31.9076H75.4575L79.9575 19.3076H82.5495ZM81.2355 22.4756L79.6515 27.0296H82.8375L81.2715 22.4756H81.2355ZM88.8464 31.9076V19.3076H91.3664V29.7476H95.6684V31.9076H88.8464ZM97.653 31.9076V19.3076H100.173V29.7476H104.475V31.9076H97.653Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinall);
export default __webpack_public_path__ + "static/media/finall.5885ce00db30361e7693d9f255e204cb.svg";
export { ForwardRef as ReactComponent };